import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Ticket, Calendar, Clock } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";
import { eur } from "../lib/format";
import * as apiClient from "../api";

export default function Account() {
  const { t } = useI18n();
  const { user } = useAuth();
  const { data: bookings = [] } = useQuery({ queryKey: ["mybookings"], queryFn: apiClient.getMyBookings, enabled: !!user });

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2">Il mio account</div>
        <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight text-slate-900">Ciao, {user?.name}</h1>
        <p className="text-slate-500 mt-1">{user?.email}</p>

        <h2 className="mt-10 text-xl font-heading font-semibold text-slate-900 mb-4">Le tue prenotazioni</h2>
        {bookings.length === 0 ? (
          <div className="text-center py-16 rounded-3xl border border-dashed border-slate-200">
            <Ticket className="h-12 w-12 text-slate-200 mx-auto mb-4" />
            <p className="text-slate-500">Nessuna prenotazione ancora.</p>
            <Link to="/esperienze" className="mt-4 inline-block rounded-full bg-primary text-white font-semibold px-6 py-2.5">{t("nav.experiences")}</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {bookings.map((b) => (
              <Link key={b.id} to={`/voucher/${b.booking_number}`} data-testid={`booking-${b.booking_number}`} className="block rounded-2xl border border-slate-100 p-5 bg-white shadow-sm hover-lift">
                <div className="flex items-center justify-between mb-3">
                  <span className="font-heading font-bold text-primary">{b.booking_number}</span>
                  <span className={`rounded-full px-3 py-1 text-xs font-semibold ${b.status === "confirmed" ? "bg-emerald-50 text-emerald-600" : b.status === "cancelled" ? "bg-red-50 text-red-500" : "bg-slate-100 text-slate-500"}`}>{b.status}</span>
                </div>
                {b.items.map((it) => (
                  <div key={`${it.experience_id}-${it.date}-${it.time}`} className="flex gap-3 items-center">
                    <img src={it.image} alt="" className="h-12 w-14 rounded-lg object-cover" />
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold text-slate-800 line-clamp-1">{it.title}</div>
                      <div className="text-xs text-slate-400 flex gap-3"><span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{it.date}</span><span className="flex items-center gap-1"><Clock className="h-3 w-3" />{it.time}</span></div>
                    </div>
                  </div>
                ))}
                <div className="mt-3 text-right font-bold text-primary">{eur(b.gmv)}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
